import * as React from 'react';
import {useCallback, useEffect, useState} from 'react';
import AssetResultContainer from "../asset-browser/AssetResultContainer";
import SidebarLeft from "../sidebar-left/SidebarLeft";
import {AssetSearchRequest, AssetSearchResponse} from "../../api";
import {URL_HELPER} from "../../App";
import {IAPIComponent} from "../pages/AssetsPage";
import {useSearchParams} from "react-router-dom";
import Cart from "../Cart";

interface AssetBrowserProps {
    api: IAPIComponent['api'];
    cart: any;
    setCart: any;
}

export const AssetBrowser = ({api, cart, setCart}: AssetBrowserProps) => {
    const [searchParams] = useSearchParams();
    const [searchResult, setSearchResult] = useState<AssetSearchResponse | null>(null);
    const [searchRequest] = useState<AssetSearchRequest>({page: 0, filters: []});

    const searchParamsToRequest = useCallback(() => {
        return {
            page: Number.parseInt(searchParams.get("page") || "0"),
            filters: URL_HELPER.parseFilters(searchParams.get("filters") || ""),
            query: searchParams.get("query") || "",
            navigationId: Number.parseInt(searchParams.get("navigation") || "")
        };
    }, [searchParams]);

    const renderSidebarLeft = () => {
        if (searchResult) {
            return (
                <SidebarLeft navigation={searchResult?.navigation}
                             facets={searchResult?.facets}
                             request={searchRequest}/>
            );
        }

        return "";
    };

    useEffect(() => {
        if (api) {
            api.getAssets({
                assetSearchRequest: searchParamsToRequest(),
                mediaCenterId: URL_HELPER.getMediaCenterId()
            }).then(response => setSearchResult(response));
        }
    }, [searchParams, api, searchParamsToRequest]);

    return (<div className="asset-browser">


        {renderSidebarLeft()}

        <div className="my-5 mx-2 w-100">
            <AssetResultContainer result={searchResult}
                                  request={searchRequest}
                                  cart={cart}
                                  setCart={setCart} />
        </div>
        <Cart cart={cart} setCart={setCart} />

    </div>);
};
export default AssetBrowser;
